import i18next from 'i18next';

import initializeValues from './initializeValues';
import openModal from './openModal';
import setMode from './setMode';

export default (values) => (dispatch) => {
    const newValues = {
        id: values.proposalId,
        project: values.projectId,
        name: values.mode
            ? values.proposalName
            : `${i18next.t('Copy of')} ${values.proposalName}`,
    };
    if (values.mode) dispatch(setMode(values.mode));
    dispatch(initializeValues(newValues));
    dispatch(openModal(true));
};
